export const StatisticsIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M17 5C16.4477 5 16 5.44772 16 6C16 6.55228 16.4477 7 17 7H20.5857L13.5 14.0857L9.20711 9.79285C8.81658 9.40232 8.18342 9.40232 7.79289 9.79285L0.292893 17.2928C-0.0976311 17.6834 -0.0976311 18.3165 0.292893 18.7071C0.683417 19.0976 1.31658 19.0976 1.70711 18.7071L8.5 11.9142L12.7929 16.2071C13.1834 16.5976 13.8166 16.5976 14.2071 16.2071L22 8.41417V12C22 12.5523 22.4477 13 23 13C23.5523 13 24 12.5523 24 12V6C24 5.44772 23.5523 5 23 5H17Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
